import { Dialog } from "@mui/material";
import { Icon } from "@iconify/react";
import { ButtonPrimary } from "../../components/utils";

interface EmailTemplatePreviewDialogProps {
  open: boolean;
  templateName: string;
  content: string;
  loading: boolean;
  sendingTest: boolean;
  onSendTest: () => void;
  onClose: () => void;
}

function EmailTemplatePreviewDialog({
  open,
  templateName,
  content,
  loading,
  sendingTest,
  onSendTest,
  onClose,
}: EmailTemplatePreviewDialogProps) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md">
      <div className="w-[900px] h-[900px] flex flex-col">
        <div className="px-10 py-5 mt-2 text-lg font-medium border-b stone-700 shrink-0">
          <h6 className="flex justify-between items-center">
            Mock Preview: {templateName?.toUpperCase()}
            <span onClick={onClose} className="cursor-pointer text-base">
              ✕
            </span>
          </h6>
        </div>
        {loading ? (
          <div className="flex items-center justify-center flex-1 text-gray-500">
            Loading preview...
          </div>
        ) : (
          <div
            className="flex-1 overflow-y-scroll px-6 py-4"
            dangerouslySetInnerHTML={{
              __html: content || "<div>No Preview Available</div>",
            }}
          />
        )}
        <div className="px-6 py-4 border-t shrink-0 flex justify-end">
          <ButtonPrimary onClick={onSendTest} disabled={sendingTest || loading}>
            {sendingTest ? "Sending..." : "Send Test Email to Me"}
          </ButtonPrimary>
        </div>
      </div>
    </Dialog>
  );
}

export default EmailTemplatePreviewDialog;
